import { FC } from "react";
import { PlayerFieldStats } from "../../schema/schema";
import { AgGridReact } from "ag-grid-react";
import sortBy from "lodash.sortby";

interface StatsTableProps {
	stats: PlayerFieldStats[];
}

type RowData = {
	Name: string;
	Matches: number;
	Catches: number;
	"WK Catches": number;
	"Non-WK Catches": number;
	Stumpings: number;
	RunOuts: number;
	"Assisted RO": number;
	"Unassisted RO": number;
};

const FieldStatsTable: FC<StatsTableProps> = ({ stats }) => {
	const sortedStats = sortBy(stats, "Name").filter(stat => !stat.Name.includes("***"));

	const rows: RowData[] = sortedStats.map(({ Name, Statistics }) => ({
		Name,
		Matches: Statistics.Matches,
		Catches: Statistics.FieldingTotalCatches,
		"WK Catches": Statistics.FieldingCatchesWK,
		"Non-WK Catches": Statistics.FieldingCatchesNonWK,
		Stumpings: Statistics.FieldingStumpings,
		RunOuts: Statistics.FieldingRunOuts,
		"Assisted RO": Statistics.FieldingAssistedRunOuts,
		"Unassisted RO": Statistics.FieldingUnassistedRunOuts
	}));

	const columns = [
		{ field: "Name" as keyof RowData, filter: true, minWidth: 180 },
		{ field: "Matches" as keyof RowData, filter: true, maxWidth: 120 },
		{ field: "Catches" as keyof RowData, filter: true, maxWidth: 120 },
		{ field: "WK Catches" as keyof RowData, maxWidth: 140 },
		{ field: "Non-WK Catches" as keyof RowData, maxWidth: 160 },
		{ field: "Stumpings" as keyof RowData, maxWidth: 120 },
		{ field: "RunOuts" as keyof RowData, maxWidth: 120 },
		{ field: "Assisted RO" as keyof RowData, maxWidth: 130 },
		{ field: "Unassisted RO" as keyof RowData, maxWidth: 140 }
	];

	return (
		<div className="w-full overflow-x-auto">
			<div className="ag-theme-quartz min-w-[940px]" style={{ height: 720 }}>
				<AgGridReact columnMenu="new" rowData={rows} columnDefs={columns} />
			</div>
		</div>
	);
};

export default FieldStatsTable;
